'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ToggleSwitch = require('./components/ToggleSwitch.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ToggleSwitch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-toggle-switch/lib/index.js
// module id = 1361
// module chunks = 1